import React from 'react';
import isEqual from 'react-fast-compare';
import EventInProgressList from '../EventInProgressList';
import './EventInProgressListWrap.scss';

const EventInProgressListWrap = (props) => {
  const {
    inProgressEvent,
    getInProgressEventList,
    getInProgressEventExcelDownload,
    setInitialInProgressEventList,
    openEventItemListModal,
    getEventTagColumnTagList,
  } = props;
  const { inProgressEventList, originalInProgressEventList } = inProgressEvent;

  return (
    <div className="event-inProgress-list-wrap">
      {/*진행중인 기획전 리스트*/}
      <EventInProgressList
        inProgressEventList={inProgressEventList}
        originalInProgressEventList={originalInProgressEventList}
        isUpdateList={!isEqual(inProgressEventList.list, originalInProgressEventList)}
        setInitialInProgressEventList={setInitialInProgressEventList}
        getList={getInProgressEventList}
        getExcelDownload={getInProgressEventExcelDownload}
        openEventItemListModal={openEventItemListModal}
        getEventTagColumnTagList={getEventTagColumnTagList}
      />
    </div>
  );
};

export default EventInProgressListWrap;
